export const sanityStudioRobotsContent = "noindex, nofollow, noarchive, nosnippet";

export function sanityStudioHead() {
  return {
    title: "Zapify CMS",
    meta: [
      { name: "robots", content: sanityStudioRobotsContent },
      { name: "googlebot", content: sanityStudioRobotsContent },
    ],
  };
}
